import React from 'react';
import auth0Login from '../../../utils/auth0/login';

class LoginEnterprise extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { params } = this.props;
    const { connection } = params;
    auth0Login('/', connection);
  }

  render() {
    return <div />;
  }
}

export default LoginEnterprise;



// WEBPACK FOOTER //
// ./src/features/login/login-enterprise/LoginEnterprise.js